/* eslint-disable no-underscore-dangle */
import React, { useState, ReactNode } from 'react';
import { Select, Empty } from 'antd';
import { useQuery } from '@apollo/react-hooks';
import BILLING_NOTES_QUERY, {
  BillingNotesData,
  BillingNotesVars,
} from 'shared/graphql/query/billingNotes';

type SelectBillingNoteFieldProps = {
  value?: string;
  onChange?: (value: string) => void;
};

const { Option } = Select;

const SelectBillingNoteField: React.FC<SelectBillingNoteFieldProps> = (props) => {
  const { value, onChange } = props;
  const [billingNumber, setBillingNumber] = useState('');
  const { loading, data } = useQuery<BillingNotesData, BillingNotesVars>(BILLING_NOTES_QUERY, {
    variables: {
      bill_number: billingNumber,
      showData: 10,
    },
    fetchPolicy: 'cache-and-network',
  });

  let options: ReactNode[] = [];
  if (data && data.billingNotes) {
    const { billingNotes } = data.billingNotes;
    options = billingNotes.map((billingNote) => (
      <Option key={billingNote._id} value={billingNote._id}>
        {billingNote.bill_number}
      </Option>
    ));
  }

  return (
    <Select
      allowClear
      style={{
        width: '100%',
      }}
      value={value}
      notFoundContent={<Empty description="ไม่มีข้อมูล" image={Empty.PRESENTED_IMAGE_SIMPLE} />}
      loading={loading}
      showSearch
      placeholder="ค้นหา"
      onSearch={(valueSearch) => setBillingNumber(valueSearch)}
      onChange={(valueChange) => onChange && onChange(valueChange)}
      optionFilterProp="children"
      filterOption={(input, option) =>
        option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {options}
    </Select>
  );
};

export default SelectBillingNoteField;
